import baseStore from './baseStore';

// Need to track both window width and client width. The client width is the
// available space which we want to use (excluding scroll bar), but the window
// width is the number reported changing.
let windowWidth = 0;
let clientWidth = 0;
let spacing = 5;

const systemStore = Object.assign(baseStore, {
  getWindowWidth: () => {
    if (!windowWidth) {
      windowWidth = window.innerWidth;
      clientWidth = document.documentElement.clientWidth;
    }
    return windowWidth;
  },
  setWindowWidth: (newWindowWidth) => {
    windowWidth = newWindowWidth;
    clientWidth = document.documentElement.clientWidth;

    systemStore.emitChange();
  },
  getClientWidth: () => {
    if (!windowWidth) {
      windowWidth = window.innerWidth;
      clientWidth = document.documentElement.clientWidth;
    }
    return clientWidth;
  },
  getPixelRatio: () => {
    return 1;
    // return window.devicePixelRatio;
  },

  getSpacing: () => {
    return spacing;
  },

  setSpacing: (newSpacing) => {
    spacing = newSpacing;
  },
});

export default systemStore;
